// extracted by mini-css-extract-plugin
export default {"IMT":"IMT_IMT__NXz6v"};